module.exports = __webpack_public_path__ + "static/whyposter-3828e16be8b41aa10164687fe77d88ca.jpg";